import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _extends from 'babel-runtime/helpers/extends';
import { push } from 'react-router-redux';
import { jsonResponse, sendJson } from 'fetch-utilities';
import _Object$assign2 from 'babel-runtime/core-js/object/assign';
import _Promise from 'babel-runtime/core-js/promise';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _Array$from from 'babel-runtime/core-js/array/from';
import _Reflect$construct from 'babel-runtime/core-js/reflect/construct';
import _Object$setPrototypeOf from 'babel-runtime/core-js/object/set-prototype-of';
import _Object$create from 'babel-runtime/core-js/object/create';
import _typeof from 'babel-runtime/helpers/typeof';
import { stringifyParams } from 'location-search-string';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = _Object$create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _Object$setPrototypeOf ? _Object$setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    var instance = _Reflect$construct(cls, _Array$from(arguments));
    _Object$setPrototypeOf(instance, _Object$getPrototypeOf(this));
    return instance;
  }

  ExtendableBuiltin.prototype = _Object$create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (_Object$setPrototypeOf) {
    _Object$setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

/**
 * Performs a deep merge of objects supplied, with the rightmost winning, skipping undefined
 * values.
 *
 * Arrays are preserved but merged by index.
 */
var objectDeepMerge = function objectDeepMerge() {
  for (var _len = arguments.length, objects = Array(_len), _key = 0; _key < _len; _key++) {
    objects[_key] = arguments[_key];
  }

  return objects.reduce(function (a, o) {
    for (var p in o) {
      if (o.hasOwnProperty(p)) {
        if (_typeof(o[p]) === "object" && o[p] && a[p]) {
          a[p] = objectDeepMerge(a[p], o[p]);
        } else if (typeof o[p] !== "undefined") {
          a[p] = o[p];
        }
      }
    }

    return a;
  }, objects[0] && Array.isArray(objects[0]) ? [] : {});
};

/**
 * Base class for application errors, carries an error code unique for the error type.
 */
var AppError = function (_extendableBuiltin2) {
  _inherits(AppError, _extendableBuiltin2);

  function AppError(message, errorCode) {
    _classCallCheck(this, AppError);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    var _this = _possibleConstructorReturn(this, _extendableBuiltin2.call(this, message));

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this, AppError);
    }

    // Custom

    _this.errorCode = errorCode;
    return _this;
  }

  return AppError;
}(_extendableBuiltin(Error));

/*
  messages.js
  ------------------------------------------------------------

  Generic message management
*/

var ADD = 'store/messages/ADD';






var addStatus = function addStatus(status, code) {
  return {
    type: ADD,
    status: status,
    code: code
  };
};

var SET = "store/order/SET";





var set$1 = function set(order) {
  return {
    type: SET,
    payload: order
  };
};

var PENDING$2 = "store/cart/PENDING";

var LOADED$2 = "store/cart/LOADED";
var ADDING = "store/cart/ADDING";

var REMOVING$1 = "store/cart/REMOVING";
var ERROR$1 = "store/cart/ERROR";
var SET_QTY$1 = "store/cart/SET_QTY";












var reset$1 = function reset() {
  return {
    type: PENDING$2
  };
};

var LOADED$3 = "store/neocart/LOADED";

var RESET$1 = "store/neocart/RESET";



/**
 * Returns true if we need to run a `load` action on the state.
 */


/**
 * Returns the cart summary.
 */


/**
 * Returns true if the cart is loaded and contains at least one item.
 */


/**
 * Returns the list of actual items in the cart.
 */


/**
 * Retrieves the current item quantity. This might differ from the actual quantity in the cart
 * since we can have pending updates.
 */




/**
 * Returns true if the quantity of the item is synchronized with the server.
 */


/**
 * Modifies a product item, does not require an item id to modify.
 */








var reset$2 = function reset() {
  return {
    type: RESET$1
  };
};



/**
 * Creates a handler from a `fetch` instance, using the `/cart` API of Crossroads_API.
 */

var ERROR$$1 = "store/checkout/ERROR";
var LOADED$$1 = "store/checkout/LOADED";
var LOADED_CART = "store/checkout/LOADED_CART";
var LOADING = "store/checkout/LOADING";
var PENDING = "store/checkout/PENDING";
var HINTED = "store/checkout/HINTED";
var REMOVING$$1 = "store/checkout/REMOVING";
var SAVING = "store/checkout/SAVING";
var SAVED = "store/checkout/SAVED";
var SET_QTY$$1 = "store/checkout/SET_QTY";
var SET_PAYMENT = "store/checkout/SET_PAYMENT";
var SET_SHIPPING = "store/checkout/SET_SHIPPING";
var SUBMITTING = "store/checkout/SUBMITTING";
var SUCCESS = "store/checkout/SUCCESS";
var UPDATE = "store/checkout/UPDATE";
var CHECK_SSN = "store/checkout/CHECK_SSN";
var GET_KLARNA_ADDRESS = "store/checkout/GET_KLARNA_ADDRESS";
var SET_KLARNA_ADDRESS = "store/checkout/SET_KLARNA_ADDRESS";
var SET_COUPON_CODE = "store/checkout/SET_COUPON_CODE";
var REMOVE_COUPON = "store/checkout/REMOVE_COUPON";
var STORED = "store/checkout/STORED";
var RESET = "store/checkout/RESET";
var REFRESH_PAYMENT_DATA = "store/checkout/REFRESH_PAYMENT_DATA";
var DELETE = "store/checkout/DELETE";

var initialState = {
  state: PENDING,
  loaded: false,
  updatingItems: [],
  removingItems: [],
  payment: {},
  data: {
    paymentMethods: [],
    shippingMethods: [],
    klarnaAddresses: [],
    billingAddress: {
      useAsShippingAddress: true
    },
    shippingAddress: {},
    cart: {
      items: [],
      summary: {}
    }
  }
};

function reducer$$1() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOADING:
    case SAVING:
    case SUBMITTING:
      return _extends({}, state, {
        state: action.type
      });

    case SUCCESS:
      {
        return _extends({}, state, {
          state: action.error ? LOADED$$1 : action.type,
          payment: action.error ? state.data : action.payload
        });
      }

    case LOADED$$1:
    case STORED:
    case SET_COUPON_CODE:
    case REMOVE_COUPON:
      return _extends({}, state, {
        loaded: true,
        state: action.error ? ERROR$$1 : LOADED$$1,
        error: action.error,
        errorData: action.error ? action.payload : null,
        data: action.error ? state.data : _extends({}, state.data, action.payload, {
          billingAddress: objectDeepMerge(state.data.billingAddress, action.payload.billingAddress),
          shippingAddress: objectDeepMerge(state.data.shippingAddress, action.payload.shippingAddress),
          paymentMethodData: objectDeepMerge(state.data.paymentMethodData, action.payload.paymentMethodData),
          email: state.data.email || action.payload.email
        })
      });

    case REFRESH_PAYMENT_DATA:
      return _extends({}, state, {
        state: action.error ? ERROR$$1 : LOADED$$1,
        error: action.error,
        errorData: action.error ? action.payload : null,
        data: action.error ? state.data : _extends({}, state.data, action.payload, {
          paymentMethods: action.payload.paymentMethods,
          paymentMethodData: action.payload.paymentMethodData
        })
      });

    case HINTED:
      return _extends({}, state, {
        state: action.type,
        data: _extends({}, state.data, action.payload)
      });

    case LOADED_CART:
      return _extends({}, state, {
        state: action.error ? ERROR$$1 : LOADED$$1,
        error: action.error,
        data: action.error ? state.data : _extends({}, state.data, { cart: action.payload }),
        errorData: action.error ? action.payload : null,
        removingItems: !action.error && action.removeId ? state.removingItems.filter(function (id) {
          return id !== action.removeId;
        }) : state.removingItems,
        updatingItems: !action.error && action.updateId ? state.updatingItems.filter(function (id) {
          return id !== action.updateId;
        }) : state.updatingItems
      });

    case REMOVING$$1:
      return _extends({}, state, {
        state: action.type,
        removingItems: [].concat(_toConsumableArray(state.removingItems), [action.removeId])
      });

    case SET_QTY$$1:
      return _extends({}, state, {
        state: action.type,
        updatingItems: [].concat(_toConsumableArray(state.updatingItems), [action.updateId])
      });

    case LOADED$2:
    case LOADED$3:
      if (state.state === PENDING) {
        return state;
      }

      return _extends({}, state, {
        state: LOADED$$1,
        data: _extends({}, state.data, {
          cart: action.payload
        })
      });

    case ERROR$1:
      if (state.state === PENDING) {
        return state;
      }

      return _extends({}, state, {
        state: ERROR$$1,
        error: action.payload
      });

    case REMOVING$1:
    case SET_QTY$1:
    case ADDING:
      return _extends({}, state, {
        state: state.state === LOADED$$1 ? LOADING : state.state
      });

    case CHECK_SSN:
      return _extends({}, state, {
        ssnStatus: action.payload.status
      });

    case UPDATE:
      {
        return _extends({}, state, {
          data: _extends({}, state.data, action.payload)
        });
      }

    case GET_KLARNA_ADDRESS:
      {
        return _extends({}, state, {
          state: LOADED$$1,
          data: action.error ? state.data : _extends({}, state.data, {
            klarnaAddresses: action.payload,
            billingAddress: action.payload.length > 1 ? state.data.billingAddress : _extends({}, action.payload[0]),
            paymentMethodData: _extends({}, state.data.paymentMethodData, {
              socialSecurityNumber: action.ssn,
              klarnaPclass: -1 // hard code invoice as the method
            })
          })
        });
      }

    case SET_KLARNA_ADDRESS:
      {
        return _extends({}, state, {
          state: LOADED$$1,
          data: _extends({}, state.data, {
            billingAddress: _extends({}, action.payload, {
              useAsShippingAddress: state.data.billingAddress.useAsShippingAddress
            })
          })
        });
      }

    case SAVED:
      return _extends({}, state, {
        state: LOADED$$1
      });

    case RESET:
    case DELETE:
      return _extends({}, initialState);

    default:
      return state;
  }
}

function getMethods(data, resp) {
  return {
    paymentMethod: data.paymentMethod || resp.paymentMethod || (resp.paymentMethods.length ? resp.paymentMethods[0].code : undefined),
    shippingMethod: data.shippingMethod || resp.shippingMethod || (resp.shippingMethods.length ? resp.shippingMethods[0].code : undefined)
  };
}

var store = function store(data) {
  return function (dispatch, getState, client) {
    dispatch({
      type: LOADING
    });

    dispatch({
      type: STORED,
      payload: client("/checkout", sendJson({ method: "PUT", body: data })).then(jsonResponse)
    });
  };
};

var save = function save(data) {
  return function (dispatch, getState, client) {
    dispatch({
      type: SAVING
    });

    dispatch({
      type: SAVED,
      payload: client("/checkout", sendJson({ method: "PUT", body: data })).then(jsonResponse)
    });
  };
};

var load = function load(data) {
  return function (dispatch, getState, client) {
    dispatch({
      type: LOADING
    });

    if (getState().checkout.data.shippingMethod !== data.shippingMethod) {
      dispatch({
        type: SET_SHIPPING
      });
    }

    if (getState().checkout.data.paymentMethod !== data.paymentMethod) {
      dispatch({
        type: SET_PAYMENT
      });
    }

    dispatch({
      type: LOADED$$1,
      payload: client("/checkout", sendJson({ method: "PUT", body: data })).then(jsonResponse).then(function (resp) {
        if (resp.cart.items.length > 0) {
          return client("/checkout", sendJson({ method: "PUT", body: getMethods(data, resp) })).then(jsonResponse);
        } else if (getState().cart.data.items.length > 0) {
          return client("/cart", sendJson({
            method: "PUT",
            body: _extends({}, getMethods(data, resp), {
              items: getState().cart.data.items.map(function (item) {
                return _extends({}, item, {
                  id: null
                });
              })
            })
          })).then(function () {
            return client("/checkout", sendJson({ method: "PUT", body: data })).then(jsonResponse);
          });
        } else {
          return resp;
        }
      }).catch(function (error) {
        if (error.errorCode === 4016) {
          return client("/checkout", sendJson({
            method: "PUT",
            body: _extends({}, getState().checkout.data, {
              paymentMethod: null
            })
          })).then(jsonResponse);
        } else {
          throw error;
        }
      })
    });
  };
};

var update = function update(data) {
  return {
    type: UPDATE,
    payload: data
  };
};

var create = function create(checkout) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (dispatch, _getState, client) {
    dispatch({
      type: SUBMITTING
    });

    dispatch({
      type: SUCCESS,
      payload: client("/checkout" + stringifyParams(params), sendJson({ body: checkout })).then(jsonResponse).then(function (order) {
        if (!order.id) {
          return;
        }

        var instantCheckoutMethods = ["Crossroads_Klarna_Invoice", "free", "Crossroads_Collector", "CrossInvoice", "checkmo"];

        if (instantCheckoutMethods.indexOf(order.paymentMethod) !== -1) {
          // Prepare so we already have it loaded on navigation
          dispatch(set$1(order));
          dispatch(push("/checkout/success?orderId=" + order.id));

          dispatch(reset$1());
          dispatch(reset$2());
          dispatch(reset$$1());
        }

        return order;
      })
    });
  };
};

var remove = function remove(id) {
  return function (dispatch, _getState, client) {
    dispatch({
      type: REMOVING$$1,
      removeId: id
    });

    dispatch({
      type: LOADED_CART,
      payload: client("/cart/" + id, { method: "DELETE" }).then(jsonResponse),
      removeId: id
    });
  };
};

var setQty = function setQty(item, qty) {
  return function (dispatch, getState, client) {
    if (qty === 0) {
      return dispatch(remove(item.id));
    }

    dispatch({
      type: SET_QTY$$1,
      updateId: item.id
    });

    dispatch({
      type: LOADED_CART,
      payload: client("/cart/" + item.id, sendJson({ method: "PUT", body: _extends({}, item, { qty: qty }) })).catch(function (error) {
        if (error.errorCode !== 2007) {
          throw error;
        }

        return client("/cart", sendJson({
          method: "PUT",
          body: {
            items: getState().cart.data.items.map(function (i) {
              return _extends({}, i, {
                id: null,
                qty: item.id === i.id ? qty : item.qty
              });
            })
          }
        }));
      }).then(jsonResponse),
      updateId: item.id
    });
  };
};

var hint = function hint(cart) {
  return {
    type: HINTED,
    payload: cart
  };
};

var getKlarnaAddress = function getKlarnaAddress(ssn) {
  return function (dispatch, _getState, client) {
    dispatch({
      type: LOADING
    });

    dispatch({
      type: GET_KLARNA_ADDRESS,
      ssn: ssn,
      payload: client("/payment/Crossroads_Klarna_Invoice/addresses?invId=" + ssn).then(jsonResponse)
    });
  };
};

var setKlarnaAddress = function setKlarnaAddress(address) {
  return function (dispatch, _getState, client) {
    /*
      dispatching LOADING and timing out the real dispatch is
      required to "recreate" the checkout form when it receives
      props saying checkout wasn"t loaded but now is.
    */

    dispatch({
      type: LOADING
    });

    setTimeout(function () {
      dispatch({
        type: SET_KLARNA_ADDRESS,
        payload: address
      });
    }, 0);
  };
};

var handleCouponError = function handleCouponError(dispatch) {
  return function () {
    dispatch(addStatus("error", "INVALID_CODE"));
    return { error: true };
  };
};

var setCouponCode = function setCouponCode(code) {
  return function (dispatch, _getState, client) {
    dispatch({
      type: LOADING
    });

    dispatch({
      type: SET_COUPON_CODE,
      payload: client("/coupon", sendJson({
        method: "PUT",
        body: {
          couponCode: code
        }
      })).then(function () {
        return client("/checkout");
      }).then(jsonResponse).catch(handleCouponError(dispatch))
    });
  };
};

var refreshPaymentData = function refreshPaymentData() {
  return function (dispatch, _getState, client) {
    dispatch({
      type: LOADING
    });

    dispatch({
      type: REFRESH_PAYMENT_DATA,
      payload: client("/checkout").then(jsonResponse)
    });
  };
};

var removeCouponCode = function removeCouponCode() {
  return function (dispatch, _getState, client) {
    dispatch({
      type: LOADING
    });

    dispatch({
      type: REMOVE_COUPON,
      payload: client("/coupon", { method: "DELETE" }).then(function () {
        return client("/checkout");
      }).then(jsonResponse)
    });
  };
};

var reset$$1 = function reset$$1() {
  return { type: RESET };
};

var terminate = function terminate() {
  return function (dispatch, _getState, client) {
    dispatch({
      type: LOADING
    });

    dispatch({
      type: DELETE,
      payload: client("/checkout", { method: "DELETE" }).then(jsonResponse)
    });
  };
};

export { ERROR$$1 as ERROR, LOADED$$1 as LOADED, LOADED_CART, LOADING, PENDING, HINTED, REMOVING$$1 as REMOVING, SAVING, SAVED, SET_QTY$$1 as SET_QTY, SET_PAYMENT, SET_SHIPPING, SUBMITTING, SUCCESS, UPDATE, CHECK_SSN, GET_KLARNA_ADDRESS, SET_KLARNA_ADDRESS, SET_COUPON_CODE, REMOVE_COUPON, STORED, RESET, REFRESH_PAYMENT_DATA, DELETE, initialState, store, save, load, update, create, remove, setQty, hint, getKlarnaAddress, setKlarnaAddress, setCouponCode, refreshPaymentData, removeCouponCode, reset$$1 as reset, terminate };
export default reducer$$1;
